import { render, staticRenderFns } from "./createObservationPoint.vue?vue&type=template&id=4809e73e&scoped=true"
import script from "./createObservationPoint.vue?vue&type=script&lang=js"
export * from "./createObservationPoint.vue?vue&type=script&lang=js"
import style0 from "./createObservationPoint.vue?vue&type=style&index=0&id=4809e73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4809e73e",
  null
  
)

export default component.exports